import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/admin/login',
      name: 'admin.login',
      component: () =>
                    import(/* webpackChunkName: "login" */ '@/views/Admin/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/admin/register',
      name: 'admin.register',
      // route level code-splitting
      // this generates a separate chunk (register.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
                    import(/* webpackChunkName: "register" */ '@/views/Admin/AuthRegister.vue'),
      meta: {
        title: Vue.i18n.translate('login.register', null),
        auth: false
      }
    },
    {
      path: '/admin/password/reset',
      name: 'admin.reset',
      component: () =>
                    import(/* webpackChunkName: "Reset" */ '@/views/Admin/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/admin/password/reset/:token',
      name: 'admin.reset.token',
      component: () =>
                    import(/* webpackChunkName: "Reset" */ '@/views/Admin/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/admin/email/verify',
      name: 'admin.verification.notice',
      props: true,
      component: () =>
                    import(/* webpackChunkName: "verification" */ '@/views/Admin/AuthVerify.vue'),
      meta: {
        title: Vue.i18n.translate('verification.title', null),
        auth: false
      }
    },
    {
      path: '/admin',
      redirect: { name: 'Dashboard' },
      component: () =>
                import(/* webpackChunkName: "User" */ '@/views/Admin/Admin.vue'),
      meta: {
        auth: true
      },
      children: [
        {
          path: '/admin/dashboard',
          name: 'Dashboard',
          component: () =>
                        import(/* webpackChunkName: "dashboard" */ '@/views/Admin/Dashboard.vue'),
          meta: {
            auth: { roles: ['Admin', 'Contabilidad'], redirect: '/admin/lots' }
          }
        },
        {
          path: '/admin/categories',
          name: 'categories',
          component: () =>
                        import(/* webpackChunkName: "categories" */ '@/views/Admin/Categories.vue'),
          meta: {
            title: Vue.i18n.translate('strings.categories', null),
            meta: {
              auth: { roles: ['Admin', 'Contabilidad'], redirect: '/admin/lots' }
            }
          },
          children: [
            {
              path: ':id',
              name: 'categoriesDetail',
              component: () =>
                                import(/* webpackChunkName: "categories" */ '@/views/Admin/Categories.vue')
            }
          ]
        },
        {
          path: '/admin/lots',
          name: 'lots',
          component: () =>
                        import(/* webpackChunkName: "lots" */ '@/views/Admin/Lots.vue'),
          meta: {
            title: Vue.i18n.translate('strings.lots', null),
            meta: {
              auth: { roles: ['Admin', 'User', 'Contabilidad'], redirect: '/admin/login' }
            }
          },
          children: [
            {
              path: ':id',
              name: 'lotsDetail',
              component: () =>
                                import(/* webpackChunkName: "lots" */ '@/views/Admin/Lots.vue')
            }
          ]
        },
        {
          path: '/admin/contacts',
          name: 'contacts',
          component: () =>
                        import(/* webpackChunkName: "contacts" */ '@/views/Admin/Contacts.vue'),
          meta: {
            title: Vue.i18n.translate('strings.contacts', null),
            meta: {
              auth: { roles: ['Admin', 'Contabilidad'], redirect: '/admin/lots' }
            }
          },
          children: [
            {
              path: ':id',
              name: 'contactsDetail',
              component: () =>
                                import(/* webpackChunkName: "contacts" */ '@/views/Admin/Contacts.vue')
            }
          ]
        },
        {
          path: '/admin/clients',
          name: 'clients',
          component: () =>
                        import(/* webpackChunkName: "contacts" */ '@/views/Admin/Clients.vue'),
          meta: {
            title: Vue.i18n.translate('strings.clients', null),
            meta: {
              auth: { roles: ['Admin', 'Contabilidad'], redirect: '/admin/lots' }
            }
          },
          children: [
            {
              path: ':id',
              name: 'clientsDetail',
              component: () =>
                                import(/* webpackChunkName: "clients" */ '@/views/Admin/Clients.vue')
            }
          ]
        },
        {
          path: '/admin/users',
          name: 'users',
          component: () =>
                        import(/* webpackChunkName: "users" */ '@/views/Admin/Users.vue'),
          meta: {
            title: Vue.i18n.translate('strings.users', null),
            auth: {
              roles: 'Admin',
              forbiddenRedirect: '/admin/dashboard'
            }
          },
          children: [
            {
              path: ':id',
              name: 'userDetail',
              component: () =>
                                import(/* webpackChunkName: "users" */ '@/views/Admin/Users.vue')
            }
          ]
        },
        {
          path: '/admin/sales',
          name: 'sales',
          component: () =>
                        import(/* webpackChunkName: "users" */ '@/views/Admin/Sales.vue'),
          meta: {
            title: Vue.i18n.translate('strings.sales', null),
            meta: {
              auth: { roles: ['Admin', 'Contabilidad'], redirect: '/admin/lots' }
            }
          },
          children: [
            {
              path: ':id',
              name: 'saleDetail',
              component: () =>
                                import(/* webpackChunkName: "users" */ '@/views/Admin/Sales.vue')
            }
          ]
        },
        {
          path: '/admin/prices',
          name: 'prices',
          component: () =>
                        import(/* webpackChunkName: "users" */ '@/views/Admin/Prices.vue'),
          meta: {
            title: Vue.i18n.translate('strings.prices', null),
            auth: {
              roles: 'Admin',
              forbiddenRedirect: '/admin/lots'
            }
          },
          children: [
            {
              path: ':id',
              name: 'priceDetail',
              component: () =>
                                import(/* webpackChunkName: "users" */ '@/views/Admin/Prices.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/customer',
      redirect: { name: 'payment' },
      component: () =>
                import(/* webpackChunkName: "verification" */ '@/views/Customer/Customer.vue'),
      meta: {
        auth: false
      },
      children: [
        {
          path: '/customer/payment',
          name: 'payment',
          component: () =>
                        import(/* webpackChunkName: "verification" */ '@/views/Customer/Payment.vue'),
          meta: {
            title: Vue.i18n.translate('payment.payment', null),
            // auth: false
            auth: {
              roles: ['Customer'],
              redirect: '/customer/register'
            }
          }
        },
        {
          path: '/customer/login',
          name: 'customer.login',
          // route level code-splitting
          // this generates a separate chunk (login.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
                        import(/* webpackChunkName: "login" */ '@/views/Customer/AuthLogin.vue'),
          meta: {
            title: Vue.i18n.translate('login.login', null),
            auth: false
          }
        },
        {
          path: '/customer/register',
          name: 'customer.register',
          // route level code-splitting
          // this generates a separate chunk (register.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
                        import(/* webpackChunkName: "register" */ '@/views/Customer/AuthRegister.vue'),
          meta: {
            title: Vue.i18n.translate('login.register', null),
            auth: false
          }
        },
        {
          path: '/customer/password/reset',
          name: 'customer.reset',
          component: () =>
                        import(/* webpackChunkName: "Reset" */ '@/views/Customer/AuthResetLink.vue'),
          meta: {
            title: Vue.i18n.translate('login.reset_password', null),
            auth: false
          }
        },
        {
          path: '/customer/password/reset/:token',
          name: 'customer.reset.token',
          component: () =>
                        import(/* webpackChunkName: "Reset" */ '@/views/Customer/AuthResetForm.vue'),
          meta: {
            title: Vue.i18n.translate('login.reset_password', null),
            auth: false
          }
        },
        {
          path: '/customer/email/verify',
          name: 'customer.verification.notice',
          props: true,
          component: () =>
                        import(/* webpackChunkName: "verification" */ '@/views/Customer/AuthVerify.vue'),
          meta: {
            title: Vue.i18n.translate('verification.title', null),
            auth: false
          }
        }
      ]
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
